import React from 'react';
import './Banner.css';

export default function Banner() {
  return (
    <div className="banner">
      <div className="banner-section">
      <h1 className="banner-heading">React-Starter-Morning</h1>
      <h4 className="banner-info">A React starter to build fast websites</h4>
      </div>
    </div>
  )
}
